module.exports = __webpack_public_path__ + "img/lego-red@2x.60a00b54.png";